export const PHOTO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/1wfm7r7i_ChatGPT%20Image%20Sep%201%2C%202026%2C%2002_19_02%20AM.png";

export const BTS_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/8dtvaqns_Screenshot%202026-09-01%20at%202.53.12%E2%80%AFAM.png";

// On-set / BTS / collab photos — nayi photos yahan add hoti jayengi
export const WORK_GALLERY = [
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/larr6biy_Screenshot%202026-09-01%20at%202.58.11%E2%80%AFAM.png",
    caption: "DRONE UNIT WITH EMRAAN HASHMI",
    tag: "STAR COLLAB • ON SET",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/rz4t1qvv_Screenshot%202026-09-01%20at%202.58.44%E2%80%AFAM.png",
    caption: "WITH RAJKUMMAR RAO",
    tag: "STAR COLLAB",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/uof0nmsr_Screenshot%202026-09-01%20at%202.58.54%E2%80%AFAM.png",
    caption: "WITH GOVIND NAMDEV JI — SHOOT DAY",
    tag: "STAR COLLAB",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/5c06c8xr_Screenshot%202026-09-01%20at%202.59.16%E2%80%AFAM.png",
    caption: "WEDDING SET — WITH THE STAR",
    tag: "STAR COLLAB • EVENT",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/rdlknzt3_Screenshot%202026-09-01%20at%202.59.01%E2%80%AFAM.png",
    caption: "WITH GOVIND NAMDEV JI — EVENT NIGHT",
    tag: "STAR COLLAB",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/u2ld2p1z_Screenshot%202026-09-01%20at%203.01.06%E2%80%AFAM.png",
    caption: "DRONE UNIT WITH CAST",
    tag: "ON SET • FEATURE FILM",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/nzaw9cbo_Screenshot%202026-09-01%20at%202.57.42%E2%80%AFAM.png",
    caption: "JIB UNIT — WEDDING SET",
    tag: "ON SET • EVENT",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/a42pyai9_Screenshot%202026-09-01%20at%202.57.24%E2%80%AFAM.png",
    caption: "DRONE CREW — OUTDOOR SHOOT",
    tag: "ON LOCATION",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/7lfq9vd5_Screenshot%202026-09-01%20at%202.59.49%E2%80%AFAM.png",
    caption: "DJI INSPIRE — MOUNTAIN SHOOT",
    tag: "ON LOCATION • AERIAL",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts/2rws6fc3_Screenshot%202026-09-01%20at%202.58.25%E2%80%AFAM.png",
    caption: "ROOFTOP DRONE OP — CITY SHOOT",
    tag: "ON LOCATION",
  },
  { src: BTS_URL, caption: "GHAMASAAN — DAY 4, SCENE 16", tag: "ON SET • FEATURE FILM" },
  { src: PHOTO_URL, caption: "FPV SETUP — GEAR LAB", tag: "FPV • CINEWHOOP" },
];

export const SOCIALS = {
  instagram: "https://www.instagram.com/filmmakerakki/",
  youtube: "https://www.youtube.com/@filmakerakki_",
  email: "",
};

// Real client quotes yahan aayenge — jab genuine reviews milenge tab bharna: { quote, name, topic }
export const TESTIMONIALS = [];

// YouTube video IDs jaise hi milenge, yahan `id` mein daal denge (e.g. id: "dQw4w9WgXcQ")
export const CLIPS = [
  {
    id: "VmXprCI8VEs",
    title: "MY FPV WORK — CLIP 01",
    poster:
      "https://images.unsplash.com/photo-1561689945-ea57f2926245?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxmcHYlMjBkcm9uZSUyMHJhY2luZyUyMG5lb258ZW58MHx8fHwxNzg4MjA3NzY5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "76adyG4YT1o",
    title: "CINEMATIC DRONE — CLIP 02",
    poster:
      "https://images.unsplash.com/photo-1495764506633-93d4dfed7c6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBkcm9uZSUyMGZseWluZyUyMGRhcmt8ZW58MHx8fHwxNzg4MjA3NzY5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "m5EmqrhD7Ho",
    title: "BUILD & FLY — CLIP 03",
    poster:
      "https://images.unsplash.com/photo-1514041884614-65858e220493?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBkcm9uZSUyMGZseWluZyUyMGRhcmt8ZW58MHx8fHwxNzg4MjA3NzY5fDA&ixlib=rb-4.1.0&q=85",
  },
];
